<template>
<div>
  <div class="container" ref="container">
    <div class="main">
      <PlateTitle :title="title"/>
    </div>
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        size="small"
        inline
        label-width="170px"
      >
      <el-form-item label="保函申请人" prop="enterpriseName">
          <el-select
            v-model="form.enterpriseName"
            placeholder="请输入"
            style="width: 350px"
            :disabled="isDisabled"
            remote
            filterable
            reserve-keyword
            :remote-method="remoteMethod"
            @change="changeEnterpriseName"
          >
            <el-option
              v-for="item in applyList"
              :key="item.id"
              :value="item.companyName"
              :label="item.companyName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业统一社会代码" prop="creditCode">
            <el-input
            disabled
            maxlength="32"
            v-model="form.creditCode"
            style="width: 350px"
          />
        </el-form-item>
        <el-form-item label="受益人" prop="beneficiary">
          <el-select
            v-model="form.beneficiary"
            placeholder="请输入"
            style="width: 350px"
            :disabled="isDisabled"
            remote
            filterable
            reserve-keyword
            :remote-method="remoteBeneficiary"
            @change="changeBeneficiary"
          >
            <el-option
              v-for="item in beneficiaryList"
              :key="item.id"
              :value="item.companyName"
              :label="item.companyName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合作机构" prop="institutionId">
          <el-select
            v-model="form.institutionId"
            placeholder="请选择"
            style="width: 350px"
            :disabled="isDisabled"
          >
            <el-option
              v-for="item in guaranteePartnerList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="担保金额" prop="sumAmount">
            <el-input
            :disabled="isDisabled"
            maxlength="32"
            v-model="form.sumAmount"
            placeholder="请输入"
            style="width: 350px"
            >
              <template slot="append">元</template>
            </el-input>
        </el-form-item>
        <el-form-item label="担保期限" prop="guaranteePeriod">
          <el-input
            maxlength="32"
            v-model="form.guaranteePeriod"
            placeholder="请输入"
            style="width: 350px"
            :disabled="isDisabled"
            >
              <template slot="append">个月</template>
            </el-input>
        </el-form-item>
        <el-form-item label="产品名称" prop="product">
          <el-select
            v-model="form.product"
            placeholder="请选择"
            style="width: 350px"
            :disabled="isDisabled"
          >
            <el-option
              v-for="item in guaranteeProductList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目性质" prop="projectNature">
          <el-select
            v-model="form.projectNature"
            placeholder="请选择"
            style="width: 350px"
            :disabled="isDisabled"
          >
            <el-option
              v-for="item in projectNatureList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <div>
          <el-form-item label="项目名称" prop="projectName">
            <el-input
              :disabled="isDisabled"
              maxlength="32"
              v-model="form.projectName"
              placeholder="请输入"
              style="width: 880px"
            />
          </el-form-item>
        </div>
        <el-form-item label="中标价" prop="bidPrice">
            <el-input
            :disabled="isDisabled"
            maxlength="32"
            v-model="form.bidPrice"
            placeholder="请输入"
            style="width: 350px"
            >
              <template slot="append">元</template>
            </el-input>
        </el-form-item>
        <el-form-item label="项目地" prop="projectLocation">
            <el-input
            :disabled="isDisabled"
            maxlength="32"
            v-model="form.projectLocation"
            placeholder="请输入"
            style="width: 350px"
          />
        </el-form-item>
        <el-form-item label="保函格式" prop="backletterFormat">
          <el-select
            v-model="form.backletterFormat"
            placeholder="请选择"
            style="width: 350px"
            :disabled="isDisabled"
          >
            <el-option
              v-for="item in backletterFormatList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最高资质等级" prop="maxAptitudeLevel">
          <el-select
            v-model="form.maxAptitudeLevel"
            placeholder="请选择"
            style="width: 350px"
            :disabled="isDisabled"
          >
            <el-option
              v-for="item in guaranteeAptitudeLevelList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="招文要求建筑资质" prop="unitAptitude">
          <el-radio-group v-model="form.unitAptitude" style="width: 350px;">
            <el-radio v-for="item in guaranteeAptitudeList" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        
      </el-form>
      <div class="btns">
        <el-button
          size="small"
          v-if="!isDisabled"
          type="primary"
          @click="onSubmit(1)"
          >提交</el-button
        >
        <el-button size="small" @click="goBack">关闭</el-button>
      </div>
  </div>
  <Footer></Footer>
</div>
</template>

<script>
import PlateTitle from '@/components/PlateTitle';
import moment from 'moment';
moment.locale('zh-cn');
import api from '@/api/enter/index.js';
import { dictDetail } from '@/api/performance.js';
import Footer from "@/views/index/footer.vue";
export default {
  name: 'EnterForm',
  components: {
    PlateTitle,
    Footer
  },
  data() {
    return {
      title: '保函录入',
      isDisabled: false,
      applyList: [],
      beneficiaryList: [],
      options: {},
      form: {
        backletterFormat: '',
        beneficiary: '',
        beneficiaryPhone: '',
        beneficiaryRegisteredAddress: '',
        bidPrice: '',
        bidderPhone: '',
        creditCode: '',
        enterpriseName: '',
        guaranteeClassification: '',
        guaranteeForm: '',
        guaranteePeriod: '',
        legalName: '',
        maxAptitudeLevel: '',
        product: '',
        productName: '',
        projectCode: '',
        projectLocation: '',
        projectName: '',
        projectNature: '',
        registeredAddress: '',
        state: '',
        sumAmount: '',
        sumMargin: '',
        sumPremium: '',
        transfer: '',
        transferBankContacts: '',
        transferBankFee: '',
        transferBankName: '',
        transferBankPhone: '',
        unitAptitude: '',
        winTenderTime: ''
      },
      rules: {
        product: [{ required: true, message: "请选择产品名称", trigger: "change" }],
        institutionId: [{ required: true, message: "请选择合作机构", trigger: "change" }],
        transfer: [{ required: true, message: "请选择是否转开", trigger: "change" }],
        transferBankName: [{ required: true, message: "请输入转开行全称", trigger: "blur" }],
        transferBankContacts: [{ required: true, message: "请输入转开行联系人", trigger: "blur" }],
        transferBankPhone: [{ required: true, message: "请输入转开联系人电话", trigger: "blur" }],
        transferBankFee: [{ required: true, message: "请输入转开行费用", trigger: "blur" }],
        enterpriseName: [{ required: true, message: "请输入保函申请人", trigger: "change" }],
        creditCode: [{ required: true, message: "请输入企业统一社会代码", trigger: "blur" }],
        // bidderPhone: [{ required: true, message: "请输入投保手机号", trigger: "blur" }],
        // legalName: [{ required: true, message: "请输入法人姓名", trigger: "blur" }],
        // registeredAddress: [{ required: true, message: "请输入注册地址", trigger: "blur" }],
        beneficiary: [{ required: true, message: "请输入受益人", trigger: "change" }],
        beneficiaryPhone: [{ required: true, message: "请输入受益人手机号码", trigger: "blur" }],
        beneficiaryRegisteredAddress: [{ required: true, message: "请输入受益人注册地址", trigger: "blur" }],
        projectName: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        projectCode: [{ required: true, message: "请输入项目编号", trigger: "blur" }],
        projectLocation: [{ required: true, message: "请输入项目地", trigger: "blur" }],
        bidPrice: [{ required: true, message: "请输入中标价", trigger: "blur" }],
        sumAmount: [{ required: true, message: "请输入担保金额", trigger: "blur" }],
        sumMargin: [{ required: true, message: "请输入实收保证金", trigger: "blur" }],
        sumPremium: [{ required: true, message: "请输入实收保费", trigger: "blur" }],
        projectNature: [{ required: true, message: "请选择项目性质", trigger: "change" }],
        backletterFormat: [{ required: true, message: "请选择保函格式", trigger: "change" }],
        maxAptitudeLevel: [{ required: true, message: "请选择最高资质等级", trigger: "change" }],
        unitAptitude: [{ required: true, message: "请选择招文要求建筑资质", trigger: "change" }],
        guaranteePeriod: [{ required: true, message: "请输入担保期限", trigger: "blur" }]
      },
      loading: false,
      loadings: false,
      guaranteePartnerList: [],
      projectNatureList: [],
      guaranteeAptitudeList: [],
      guaranteeAptitudeLevelList: [],
      backletterFormatList: [],
      guaranteeProductList: []
    };
  },
  mounted() {
    this.getDictDetail();
    if(this.$route.query.type === 'look') {
      this.title = '查看保函'
      this.form = JSON.parse(sessionStorage.getItem('row'));
       console.log(this.form, 111)
       this.form.institutionId = String(this.form.institutionId)
      this.isDisabled = true
    } else if(this.$route.query.type === 'add') {
      this.title = '保函录入'
      this.isDisabled = false
      this.form.product = this.$route.query.productV
    } else {
      this.title = '编辑保函'
      this.isDisabled = false
    }
  },
  methods: {
    getDictDetail() {
      dictDetail({ dictName: 'guaranteePartner' }).then(res => {
        this.guaranteePartnerList = res.data.data;
      });
      dictDetail({ dictName: 'projectNature' }).then(res => {
        this.projectNatureList = res.data.data;
      });
      dictDetail({ dictName: 'guaranteeAptitude' }).then(res => {
        this.guaranteeAptitudeList = res.data.data;
      });
      dictDetail({ dictName: 'guaranteeAptitudeLevel' }).then(res => {
        this.guaranteeAptitudeLevelList = res.data.data;
      });
      dictDetail({ dictName: 'backletterFormat' }).then(res => {
        this.backletterFormatList = res.data.data;
      });
      dictDetail({ dictName: 'guaranteeProduct' }).then(res => {
        this.guaranteeProductList = res.data.data;
      });
    },
    remoteMethod(query) {
      if(query.length > 3) {
        api.getSelectList({companyName: query}).then(res => {
          this.applyList = res.data.data.data.list
        })
      }
    },
    changeEnterpriseName(e) {
      this.options = this.applyList.filter(item => {
        return item.companyName === e
      });
      api.getSelectListInfo({cid: this.options[0].cid, companyName: this.options[0].companyName, creditCode: this.options[0].creditCode}).then(res => {
        this.form.creditCode = res.data.data.data.creditCode
        this.form.bidderPhone = res.data.data.data.contactPhone
        this.form.legalName = res.data.data.data.operName
        this.form.registeredAddress = res.data.data.data.addressDetail
      })
    },
    remoteBeneficiary(query) {
      if(query.length > 3) {
        api.getSelectList({companyName: query}).then(res => {
          this.beneficiaryList = res.data.data.data.list
        })
      }
    },
    changeBeneficiary(e) {
      this.options = this.beneficiaryList.filter(item => {
        return item.companyName === e
      });
      api.getSelectListInfo({cid: this.options[0].cid, companyName: this.options[0].companyName, creditCode: this.options[0].creditCode}).then(res => {
        this.form.beneficiaryPhone = res.data.data.data.contactPhone
        this.form.beneficiaryRegisteredAddress = res.data.data.data.addressDetail
      })
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.state = 1
          this.form.productName = this.guaranteeProductList.filter(item => {
            if(item.value === this.form.product) {
              return item
            }
          })[0].label;
          this.form.institutionName = this.guaranteePartnerList.filter(item => {
            if(item.value === this.form.institutionId) {
              return item
            }
          })[0].label;
          if(this.title == "保函录入") {
            api.add(this.form).then(res => {
              this.$message({
                message: "操作成功！",
                type: "success"
              });
              console.log(1111)
              this.$router.push({ path: "/orderCenter" });
            });
          } else {
            api.edit(this.form).then(res => {
              this.$message({
                message: "操作成功！",
                type: "success"
              });
              this.$router.push({ path: "/orderCenter" });
            });
          }
        }
      });
    },
    goBack() {
      history.go(-1);
    }
  },
};
</script>
<style lang="less" scoped>
.container {
  background-color: #fff;
  margin: 30px auto;
  min-height: 700px;
  padding: 20px;
  width: 1200px;
}
.el-button {
  width: 150px;
  margin-top: 30px;
}
.btns {
  text-align: center;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 30px;
}
</style>
